<template>
  <div class="unlock-post-with-tokens-modal">
    <ModalFullBackdrop>
      <div class="container spinner" v-if="sendingLoading">
        <Spinner />
      </div>
      <div class="container" v-if="!sendingLoading && !postUnlocked">
        <h3 class="modal-title">Desbloquear Contenido</h3>
        <p class="content-text">
          {{
            $t("tokens_modal.description_unlock_post", {
              tokens_quantity: post.tokens_quantity,
            })
          }}
          <span class="username">@{{ model.username }}</span>
        </p>
        <p class="content-text">
          {{
            $t("tokens_modal.tokens_available_quantity", {
              balance: balanceLoaded ? balance : "",
            })
          }}
        </p>
        <p
          class="content-text error-message"
          v-if="post.tokens_quantity > balance && balanceLoaded"
        >
          {{ $t("tokens_modal.not_enough_tokens_to_unlock") }}
        </p>
        <div class="footer">
          <button class="cancel" @click="cancelHandler">
            {{ $t("tokens_modal.button_back") }}
          </button>
          <router-link
            class="action"
            :to="{ name: 'purchase.tokens' }"
            v-if="post.tokens_quantity > balance && balanceLoaded"
          >
            <button>{{ $t("tokens_modal.button_buy_tokens") }}</button>
          </router-link>
          <button v-if="post.tokens_quantity <= balance" @click="sendTokens">
            {{ $t("tokens_modal.button_unlock") }}
          </button>
        </div>
      </div>
      <div class="container" v-if="postUnlocked">
        <h3 class="modal-title" style="color: green">Desbloqueado</h3>
        <p class="content-text">
          {{
            $t("tokens_modal.success_transaction", {
              tokens_quantity: post.tokens_quantity,
            })
          }}
        </p>
        <div class="footer">
          <button class="cancel" @click="cancelHandler">
            {{ $t("tokens_modal.button_back") }}
          </button>
        </div>
      </div>
    </ModalFullBackdrop>
  </div>
</template>

<script setup lang="ts">
import resources from '@/utils/resources';

import { PostData } from '~/types/Post';
import _NuxtApp from '~/types/NuxtApp';

const { $EventBus } = <_NuxtApp>useNuxtApp();

const $emit = defineEmits<{
  (event: "cancel"): void;
}>();

interface _Props {
  model: any;
  post: PostData;
};

const { post, model } = defineProps<_Props>();

const balance = ref(0);
const sendingLoading = ref(false);
const postUnlocked = ref(false);
const balanceLoaded = ref(false);

function cancelHandler() {
  $emit('cancel');
}

function sendTokens() {
  sendingLoading.value = true;
  resources.tokens.store({
    model_id: model.id,
    post_id: post.post_id,
    tokens: post.tokens_quantity,
  })
    .then(() => {
      sendingLoading.value = false;
      postUnlocked.value = true;
      $EventBus.unlockPostWithTokens(model, post);
    })
    .catch(() => {
      // if (error.data.error && error.data.error == 'Not enough tokens') {
      //   notEnoughTokens = true;
      // }
      sendingLoading.value = false;
    });
}

function getTokensBalance() {
  resources.tokens.balance().then(({ data }) => {
    balance.value = data.balance;
    balanceLoaded.value = true;
  });
}

onMounted(() => {
  getTokensBalance();
});
</script>

<style lang="scss" scoped>
.unlock-post-with-tokens-modal {
  & .spinner {
    align-items: center;
    display: flex;
    min-width: 300px;
    min-height: 300px;
    justify-content: center;
  }

  & .container {
    box-sizing: border-box;
    border-radius: 1rem;
    border: solid 2px #ccc;
    padding: 1rem;

    @media (min-width: 768px) {
      min-width: 350px;
      width: 500px;
    }

    & .modal-title {
      font-size: 1.5rem;
      text-transform: uppercase;
    }

    & h3 {
      margin: 0.5rem 0;
    }

    & .content-text {
      font-weight: bold;
      text-transform: uppercase;
    }

    & .footer {
      display: flex;
      justify-content: flex-end;

      & button,
      .action {
        border-radius: 0.5rem;
        margin-left: 1rem;
        font-size: 1rem;
        font-weight: bold;
        text-transform: uppercase;
        padding: 0.5rem 1rem;
      }

      & .action {
        padding: 0;
      }

      & .action > button {
        margin-left: 0;
      }
    }
  }

  & button.cancel {
    background-color: var(--pallete_main_color);
    color: var(--pallete_clear_text_color);
  }

  & .error-message {
    color: red;
  }

  & .username {
    font-weight: bold;
  }
}
</style>
